import React, { useState, useEffect } from 'react';
import './d-productosdestacados.css';
import './m-productosdestacados.css';

const ProductosDestacados = ({
  title = 'Productos destacados.',
  eyebrow = 'Selección',
  description = 'Una selección de lo que están publicando las tiendas.',
  limit = 8,
}) => {
  const [productosDestacados, setProductosDestacados] = useState([]);

  useEffect(() => {
    const obtenerProductosDestacados = async () => {
      try {
        const response = await fetch('/api/productos/destacados');
        if (!response.ok) {
          throw new Error('Error al obtener los productos destacados');
        }
        const productos = await response.json();
        const productosAleatorios = obtenerProductosAleatorios(productos, 20);
        setProductosDestacados(productosAleatorios);
      } catch (error) {
        console.error('Error al obtener los productos destacados:', error);
      }
    };

    obtenerProductosDestacados();
  }, []);

  const obtenerProductosAleatorios = (productos, cantidad) => {
    const productosAleatorios = [];
    const copiaProductos = productos.slice();

    while (productosAleatorios.length < cantidad && copiaProductos.length > 0) {
      const indiceAleatorio = Math.floor(Math.random() * copiaProductos.length);
      const productoAleatorio = copiaProductos.splice(indiceAleatorio, 1)[0];
      productosAleatorios.push(productoAleatorio);
    }

    return productosAleatorios;
  };

  const redireccionarAviso = (idAviso) => {
    const url = new URL(`/aviso/${idAviso}`, window.location.origin);
    window.location.href = url.toString();
  };

  const generarRecuadro = (producto) => (
    <article
      key={producto.Idaviso}
      className="recuadro"
      onClick={() => redireccionarAviso(producto.Idaviso)}
    >
      <div className="d-recuadrocontent">
        <div className="recuadro-media">
          <img src={producto.Imagenes[0]} alt={producto.Titulo} />
        </div>
        <div className="recuadro-body">
          <span className="recuadro-tag">Destacado</span>
          <div className="recuadro-titulo">
            <p>{producto.Titulo}</p>
          </div>
          <div className="recuadro-precio">
            <h3>{'$' + producto.Precio}</h3>
          </div>
        </div>
      </div>
      <div className="m-recuadrocontent">
        <div className="recuadro-media">
          <img src={producto.Imagenes[0]} alt={producto.Titulo} />
        </div>
        <div className="recuadro-body">
          <span className="recuadro-tag">Destacado</span>
          <div className="recuadro-titulo">
            <p>{producto.Titulo}</p>
          </div>
          <div className="recuadro-precio">
            <h3>{'$' + producto.Precio}</h3>
          </div>
        </div>
      </div>
    </article>
  );

  return (
    <div id="productos-destacados">
      <div className="productos-destacados-heading">
        <div>
          <span className="productos-destacados-eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
        </div>
        <p>{description}</p>
      </div>
      <div className="productos-destacados-grid">
        {productosDestacados.slice(0, limit).map((producto) => generarRecuadro(producto))}
      </div>
    </div>
  );
};

export default ProductosDestacados;
